import React from 'react';
import NativeSelect from '@mui/material/NativeSelect';

class TimeFilter extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            data : [],
            maxYear: 0
        };
    }


    API_URL = "/yearFilter";
    componentDidMount() {
        this.props.onLoading(true);
        var maxYear = "";
        fetch(this.API_URL)
            .then((res) => res.json())
            .then((data1) => {
                maxYear =data1[0].anio;
                this.setState(() => ({
                    data: data1,
                    maxYear: maxYear
                }), ()=>{
                        this.props.onLoading(false);
                    }
                );

            });
    }

    render() {
        return(
            <div name="yearFilter">
                <h5>Año
                    <NativeSelect
                        style={{width: '50%', padding: '2px', marginTop: '2px', marginLeft: '10px'}}
                        defaultValue={30}
                        onChange={e => this.props.handleChange(e)}
                        inputProps={{
                            name: 'anio',
                            id: 'uncontrolled-native',
                        }}
                        maxYear = {this.state.maxYear} >
                        {this.state.data.map(item => <option key={item.anio}>{item.anio}</option>)}
                    </NativeSelect>

                </h5>
            </div>
        )
    }
}
export default TimeFilter;
